import { secureApi } from 'services/api';
import { MaintenanceHistoryIdsDto } from 'services/api/maintenance/types';
import { EntityForIdMutationArg } from 'services/api/utils';

export const maintenanceApi = secureApi.injectEndpoints({
  endpoints: builder => ({
    deleteMaintenanceHistory: builder.mutation<
      void,
      EntityForIdMutationArg<MaintenanceHistoryIdsDto>
    >({
      query: ({ id, payload }) => ({
        url: `/apiv2/user/equipment/${id}/maintenance`,
        method: 'DELETE',
        data: payload,
      }),
      // TODO add when maintenance history is fetched by RTK Query
      // invalidatesTags: (_, __, { id }) => [
      //   { type: 'Maintenance History', id: id },
      // ],
    }),
    restoreMaintenanceHistory: builder.mutation<
      void,
      EntityForIdMutationArg<MaintenanceHistoryIdsDto>
    >({
      query: ({ id, payload }) => ({
        url: `/apiv2/user/equipment/${id}/maintenance/restore`,
        method: 'POST',
        data: payload,
      }),
      // TODO add when maintenance history is fetched by RTK Query
      // invalidatesTags: (_, __, { id }) => [
      //   { type: 'Maintenance History', id: id },
      // ],
    }),
  }),
  overrideExisting: true,
});
